import {Mapper} from '@s-ui/domain'

export default class UserFavoriteRawDataToUserFavoriteEntityMapper extends Mapper {
  /**
   * @param {object} config
   * @param {AdEntity} enity
   */
  constructor({config, entity}) {
    super()
    this._config = config
    this._entity = entity
    this._compareNumber = (a, b) => {
      return a - b
    }
  }

  _getSubscriptionMonthlyFee = ({subscriptionPriceOptions = []}) => {
    return subscriptionPriceOptions.reduce((minimumMonthlyFee, {monthlyPrice}) => {
      if (minimumMonthlyFee === 0) return monthlyPrice
      return monthlyPrice < minimumMonthlyFee ? monthlyPrice : minimumMonthlyFee
    }, 0)
  }

  _getSubscriptionData(rawAd) {
    const {subscriptionData = {}, transmissionTypeId} = rawAd

    const commitmentsConfigurations = subscriptionData.commitmentsConfigurations

    if (!commitmentsConfigurations) return

    const {selected: selectedCommitment, otherOptions: otherCommitmentOptions} = commitmentsConfigurations

    const {kmIncludedPeriod, kmIncluded} = selectedCommitment

    const commitmentMonthlyOptions = Array.from(new Set(otherCommitmentOptions.map(option => option.totalMonths))).sort(
      this._compareNumber
    )

    const hasNoCommitmentOption = [selectedCommitment, ...otherCommitmentOptions]
      .map(option => option.totalMonths)
      .includes(0)

    return {
      commitmentMonthlyOptions,
      hasNoCommitmentOption,
      isSubscription: true,
      kmIncluded,
      kmIncludedPeriod,
      monthlySubscriptionCommitment: selectedCommitment.totalMonths,
      monthlySubscriptionFee: selectedCommitment.monthlyPrice,
      subscriptionVehicleState: subscriptionData.vehicleState,
      transmissionTypeId
    }
  }

  map = rawUserFavorite => {
    if (rawUserFavorite.favoriteData.filteredProvinces === undefined)
      rawUserFavorite.favoriteData.filteredProvinces = this._config.get('filteredProvincesResults').UNKNOWN

    rawUserFavorite.financingInfo = rawUserFavorite.financingData
    delete rawUserFavorite.financingData

    const hasSubscriptionFeatures =
      rawUserFavorite.subscriptionFeatures && Object.entries(rawUserFavorite.subscriptionFeatures).length !== 0

    const subscriptionPriceOptions = rawUserFavorite.subscriptionFeatures?.commitments

    return this._entity({
      ...rawUserFavorite,
      ...(hasSubscriptionFeatures && {
        ...this._getSubscriptionData(rawUserFavorite),
        monthlySubscriptionFee: this._getSubscriptionMonthlyFee({
          subscriptionPriceOptions
        })
      }),
      priceAverageIndicator: rawUserFavorite.indicator?.average,
      priceRankIndicator: rawUserFavorite.indicator?.rank,
      config: this._config,
      ...(rawUserFavorite.isProfessional && {
        seller: {
          ...rawUserFavorite.seller,
          contractId: rawUserFavorite.seller?.contractId || rawUserFavorite.contractId,
          sellerMessagingId: rawUserFavorite.seller?.contractId
            ? `pro-${rawUserFavorite.seller?.contractId}`
            : `pro-${rawUserFavorite.contractId}`
        }
      })
    })
  }
}
